import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useGrowthData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();

  const { data: growthData, isPending } = useQuery({
    queryKey: [QueryKey.GrowthSection, datasetId, id],
    queryFn: () =>
      Plants.getGrowth({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }),
    enabled: shouldFetchData,
  });

  return { growthData, isPending };
};
